import { TokenStandardType } from '@archax/shared-types'
import { StrKey } from 'stellar-sdk'

export const isValidStellarAddress = (address?: string): boolean => {
  try {
    return StrKey.isValidEd25519PublicKey(address)
  } catch (error) {
    // If any error occurs during validation, return false
    return false
  }
}

export const isValidStellarTokenAddress = (address?: string): boolean => {
  try {
    const parts = `${address || ''}`.split('-')
    if (parts.length === 2) {
      return StrKey.isValidEd25519PublicKey(parts[1])
    }
    return StrKey.isValidEd25519PublicKey(address)
  } catch (error) {
    // If any error occurs during validation, return false
    return false
  }
}
